import React, { useState, useCallback, useMemo, memo } from "react"
import { useSelector, useDispatch } from "react-redux"
import Box from "@material-ui/core/Box"
import ProgressBar from "@/components/common/ProgressBar"
import ProgressRing from "@/components/common/ProgressRing"
import { makeStyles } from "@material-ui/core/styles"
import globalUseStyles from "@/globalUseStyles"
import clsx from "clsx"
import { selectedParticipant, deselectedParticipant } from "@/redux/actions/controlPanelSelectedParticipantAction"
import { controlPanelSidebarOpenComponent } from "@/redux/actions/controlPanelSidebarAction"

const useStyles = makeStyles((theme) => ({
    participantProgressWrapper: {
        position: "relative",
        background: "#ffffff",
    },
    participantProgressWrapperIsSelected: {
        background: "linear-gradient(-45deg,#161617,#364556)",
        color: "#ffffff",
    },
    progressWrapper: {
        position: "relative",
    },
    participantLabel: {
        position: "relative",
        textAlign: "center",
        padding: theme.spacing(3, 2),
        paddingTop: "0",
    },
}))
const ParticipantProgress = memo((props) => {
    const { participant } = props
    const [clickElement, setClickElement] = useState(false)
    const { selectedStatus, selectedParticipantId } = useSelector((state) => state.controlPanelSelectedParticipantReducer)
    const styleProps = {
        clickElement,
        selectedStatus,
    }
    const classes = useStyles(styleProps)
    const globalClasses = globalUseStyles()

    const dispatch = useDispatch()

    const label = useMemo(
        () => participant.firstName + (participant.lastName ? ` ${participant.lastName.substring(0, 1)}.` : ""),
        [participant]
    )
    const progress = useMemo(() => participant.responseCount, [participant])
    const outOf = useMemo(() => participant.questionCount, [participant])

    const progressLabel = useMemo(() => {
        return `${participant.responseCount}/${participant.questionCount} questions completed`
    }, [participant])

    const isSelected = useMemo(() => {
        return selectedParticipantId === participant.participantId
    }, [selectedStatus, selectedParticipantId])

    const selectAction = (selectActionParticipant) => {
        // deselect all
        dispatch(deselectedParticipant())
        if (selectedParticipantId === selectActionParticipant.participantId) {
            // re-click the same participant, revert
            setClickElement(false)
            const allTag = process.env.SPARCA_CONTROL_PANEL_SIDEBAR_ICONS_SELECT
            dispatch(controlPanelSidebarOpenComponent(allTag))
        } else {
            setClickElement(true)
            // select the chosen participant
            dispatch(selectedParticipant({ participant: selectActionParticipant }))
            const sidebarTag = process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PARTICIPANT_SETTINGS
            dispatch(controlPanelSidebarOpenComponent(sidebarTag))
        }

        // if (isSelected()) {
        //     dispatch(deselectedParticipant())
        //     dispatch(sidebarOpenUpdate(SPARCA_ALL))
        // } else {
        //     const selectedParticipantIdNew = participant.id
        //     let status = null
        //     if (selectedParticipantDetail && selectedParticipantDetail.selectedId) {
        //         status = 1 // keep
        //     }
        //     dispatch(selectedParticipant(selectedParticipantIdNew, status))
        //     dispatch(sidebarOpenUpdate(SPARCA_PARTICIPANT_SETTINGS))
        // }
    }

    const handleParticipantOnClick = useCallback(
        (e) => {
            e.stopPropagation()
            selectAction(participant)
        },
        [selectedStatus, selectedParticipantId, clickElement]
    )

    const handleParticipantOnKeyPress = useCallback(
        (event) => {
            if (event.key === "Enter") {
                selectAction()
            }
            if (event.key === "Escape") {
                dispatch(deselectedParticipant())
            }
        },
        [selectedStatus, selectedParticipantId, clickElement]
    )

    return (
        <Box
            className={clsx(classes.participantProgressWrapper, {
                [classes.participantProgressWrapperIsSelected]: isSelected,
            })}
            // tabIndex="0"
            onKeyDown={handleParticipantOnKeyPress}
            onClick={handleParticipantOnClick}
        >
            <Box className={classes.progressWrapper}>
                <Box className={classes.ProgressRingWrapper} display={{ xs: "none", md: "block" }}>
                    <ProgressRing progress={progress} outOf={outOf} label={progressLabel} />
                </Box>
                <Box className={classes.ProgressBarWrapper} display={{ xs: "block", md: "none" }}>
                    <ProgressBar progress={progress} outOf={outOf} label={progressLabel} />
                </Box>
            </Box>
            <Box className={clsx(classes.participantLabel, globalClasses.smallFont)}>{label}</Box>
        </Box>
    )
})

export default ParticipantProgress
